import { __decorate } from "tslib";
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { SharedHttp } from '../../services/http-client.service';
/**
 * Sms Confirmation Component
 */
let SmsConfirmationComponent = class SmsConfirmationComponent {
    constructor(sanitizer, themeService, httpClient) {
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.httpClient = httpClient;
        this.linkColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.errorColor = '';
        this.tokenError = false;
        this.smsSent = false;
        this.smsNotSent = false;
        this.errorSMSMessage = '';
        this.smsError = true;
        this.dataObject = {};
        this.borderRadiusSmaller = '';
        this.themeService.getTheme().subscribe((data) => {
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
    }
    ngOnInit() {
    }
    checkToken() {
        this.errorMessage = '';
        const token = this.dataObject.token;
        const regEx = /^[0-9]{6}$/;
        if (regEx.test(token) === false) {
            this.tokenError = true;
            this.smsError = true;
            return !this.tokenError;
        }
        else {
            this.tokenError = false;
            this.smsError = false;
            return !this.tokenError;
        }
    }
    resendSMS() {
        this.smsNotSent = false;
        this.smsSent = false;
        if (typeof this.orderId !== 'undefined') {
            this.httpClient.post('market/order/guest/resendsms', {
                order_id: this.orderId
            }).subscribe((result) => {
                this.smsSent = true;
            }, (error) => {
                this.smsNotSent = true;
                this.errorSMSMessage = error.error['message'];
            });
        }
    }
};
SmsConfirmationComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: SharedHttp }
];
__decorate([
    Input()
], SmsConfirmationComponent.prototype, "orderType", void 0);
__decorate([
    Input()
], SmsConfirmationComponent.prototype, "errorMessage", void 0);
__decorate([
    Input()
], SmsConfirmationComponent.prototype, "orderId", void 0);
__decorate([
    Input()
], SmsConfirmationComponent.prototype, "isGuest", void 0);
SmsConfirmationComponent = __decorate([
    Component({
        selector: 'ecd-sms-confirmation',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./sms-confirmation.component.html")).default
    })
], SmsConfirmationComponent);
export { SmsConfirmationComponent };
